import mainImage from './boho_tablecloth.jpg';
import image1 from './boho_tablecloth1.jpg';
import image2 from './boho_tablecloth2.jpg';
import image3 from './boho_tablecloth3.jpg';
import image4 from './boho_tablecloth4.jpg';


const details = [
    { 
      id: 1,
      name: 'Boho Tablecloth',
      slideTitle: 'Boho Tablecloth',
      slideImage: mainImage,
      images: [mainImage, image1, image2, image3, image4],
      description: 'Designed for aesthetic appeal and functionality, it\'s perfect for any event. We\'ve made this decorative table clothes with functionality and durability in mind. It\'s easy to clean but still has a nice weight to it. The boho pattern intentionally adds a fun, subtle touch to the table setting.',
      link: 'https://amzn.to/3Zu2AC5',
    }
]

export default details[0];